<div class="modal-minhas-listas-replace">
  <i
    class="fa fa-close modal-minhas-listas-replace__close"
    aria-hidden="true"
    (click)="close()"
  ></i>
  <app-produtos-indisponiveis-lista [products]="products" [modalLevel]=1 (afterReplace)="afterReplace($event)" ></app-produtos-indisponiveis-lista>
</div>
